import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../apis/index";

const initialState = {
  status: "idle",
  error: null,
  message: null,
  bannerData: null,
  isActive: false,
};

export const getBanner = createAsyncThunk(
  "banner/getBanner",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(`home/site-banner`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const homeBannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {},
  extraReducers: {
    [getBanner.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getBanner.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.bannerData = action.payload?.data;
      state.isActive = true;
    },
    [getBanner.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default homeBannerSlice.reducer;
